/*
 * Actions for the [board store]{link module:store/board}
 *
 * @module store/board/actions
 */

export function createCompRule({ state, commit }, { gId, name, type }) {
  if (findCompRuleByType({ gs: state.config, gId, type })) {
    return null
  }

  commit('CREATE_COMP_RULE', { gId, name, type })

  return findCompRuleByType({ gs: state.config, gId, type })
}

const findCompRuleByType = ({ gs, gId, type }) => {
  let compRule = null
  for (const g of gs) {
    if (g.id === gId) {
      for (const c of g.compRules) {
        if (c.type === type) {
          return c
        }
      }
    }
    compRule = compRule ?? findCompRuleByType({ gs: g.children, gId, type })
  }

  return compRule
}
